import ConfirmLeadData from './ConfirmLeadData';
export default ConfirmLeadData;
